import { Button, Group, Paper, Stack, Text } from '@mantine/core';
import type { PwaInstallControls } from '@/lib/pwa-install';

interface AppInstallPromptProps {
  install: PwaInstallControls;
}

export default function AppInstallPrompt({ install }: AppInstallPromptProps) {
  if (!install.visible) return null;

  return (
    <Paper withBorder radius="md" p="md" w="100%" c="dark" bg="white">
      <Stack gap="xs">
        <Text fw={600}>Add ParcelQuest to your Home Screen</Text>
        {install.platform === 'ios' ? (
          <Text size="sm">
            Open your browser’s Share menu, then choose <strong>Add to Home Screen</strong>.
            If it is missing, open this page in Safari and try again.
          </Text>
        ) : install.canPrompt || install.installing ? (
          <Text size="sm">Install ParcelQuest for quick access from your Home Screen.</Text>
        ) : (
          <Text size="sm">
            Open your browser’s menu and look for <strong>Install app</strong> or{' '}
            <strong>Add to Home screen</strong>. Availability depends on your browser.
          </Text>
        )}
        {install.error && <Text size="sm" c="red" role="alert">{install.error}</Text>}
        <Group justify="flex-end" gap="xs">
          <Button variant="subtle" color="dark" onClick={install.dismiss} disabled={install.installing}>
            Not now
          </Button>
          {(install.canPrompt || install.installing) && (
            <Button color="pq-red" onClick={install.install} loading={install.installing}>
              Install app
            </Button>
          )}
        </Group>
      </Stack>
    </Paper>
  );
}
